import { app } from '../../../../app';
import { Controller } from './mobile-app-support.controller';

app.component('companyManageApplicationMobileAppSupport', {
    bindings: {
        application: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./mobile-app-support.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/mobile-app-support/mobile-app-support.component.js